import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { HomeDashboardService } from '../../data/services/view/home-dashboard.service';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';

@Component({
  selector: 'app-monthly-target',
  templateUrl: './monthly-target.component.html',
  styleUrls: ['./monthly-target.component.scss'],
})
export class MonthlyTargetComponent implements OnInit {
  data: any;
  options: any;
  platformId = inject(PLATFORM_ID);

  constructor(
    private readonly dashboardService: HomeDashboardService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loadChartData();
  }

  loadChartData() {
    this.dashboardService.monthlyTarget().subscribe((response) => {
      if (isPlatformBrowser(this.platformId)) {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--p-text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--p-text-muted-color');
        const surfaceBorder = documentStyle.getPropertyValue('--p-content-border-color');

        this.data = {
          labels: Object.keys(response.data),
          datasets: [
            {
              type: 'line',
              label: 'Cobrado',
              borderColor: '#f97315',
              borderWidth: 3,
              fill: false,
              tension: 0.4,
              data: Object.values(response.data).map((month: any) => month.collectedAmount)
            },
            {
              type: 'bar',
              label: 'Objetivo',
              backgroundColor: '#09b6d5',
              data: Object.values(response.data).map((month: any) => month.targetAmount),
              borderColor: 'black',
              borderWidth: 2
            }
          ]
        };

        this.options = {
          maintainAspectRatio: false,
          aspectRatio: 0.6,
          plugins: {
            legend: {
              labels: {
                color: textColor
              }
            }
          },
          scales: {
            x: {
              ticks: {
                color: textColorSecondary
              },
              grid: {
                color: surfaceBorder
              }
            },
            y: {
              ticks: {
                color: textColorSecondary
              },
              grid: {
                color: surfaceBorder
              }
            }
          }
        };
        this.cd.markForCheck();
      }
    });
  }
}
